<template>
	<div id="search">
		<form @submit.prevent="searchTerm">
			<div class="pseudo-search">
				<input 
					type="text"
					v-model="search"  
					:placeholder="$t('search')" 
					required />
				<i v-if="showCloseIcon" class="fa fa-times" @click="clearSearch"></i>
				<button class="fa fa-search" type="submit"></button>
			</div>
		</form>
	</div>
</template>

<script>
	export default {
    data() {
      return {
        search: '',
        showCloseIcon: false
      }
    },
    methods: {
      searchTerm() {
        this.showCloseIcon = true
        if (this.$parent.searchTerm) this.$parent.searchTerm(this.search.trim())
        else this.$parent.$parent.searchTerm(this.search.trim())
      },
      clearSearch() {
        this.search = ''
        this.showCloseIcon = false
        if (this.$parent.clearSearch) this.$parent.clearSearch()
        else this.$parent.$parent.clearSearch()
      }
    }
	}
</script>

<style lang="scss" scoped>
html, body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 16px;
}

div#search {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 2rem;

  
form {
  display: inline-block;
  margin: 0 auto;
}

.pseudo-search {
  display: inline;
  border: 2px solid #ccc;
  border-radius: 100px;
  padding: 10px 15px;
  transition: background-color 0.5 ease-in-out;
  .fa-times:before {
    margin-right: 10px;
}

  input {
    border: 0;
    background-color: transparent;
    width: 200px;

    &:focus {
      // Unsure how to fix this...
      outline: none;
    }
  }
  
  button, i {
    border: none;
    background: none;
    cursor: pointer;
  }
  
  select {
    border: none;
  }
}
}

@media screen and (min-width: 1200px) {
div#search {
  display: block; 
}
}
</style>